import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled, { StylesProps } from '../../lib/styles';
import { compose, withProps } from 'recompose';
import { Collection as CollectionModel } from '../../models/collection';
import memoize from '../../lib/selectorUtils';
import { Ads } from '../../components/presentational/Ad';
import Metadata from './Metadata';
import { withTracking } from '../../lib/ga';
import { SHOW_MORE_STORIES } from './lib/ga';
import { callOnMount } from '../../behaviour/patterns';
import { collectionSelector, adsSelector, Brand } from './store/selectors';
import {
  loadMoreArticlesThunk,
  loadPopularArticlesThunk,
} from './store/actions';
import { Block } from './store/reducer';
import collectionStyles from './Collection_styles';
import CollectionBlock from './CollectionBlock';
import AdSetup from '../../components/presentational/Ad/AdSetup';
import pick from 'lodash/pick';
import { ArticleBlockData } from './CollectionBlock/Blocks/ArticleBlock';
import { kebabCase } from 'lodash';
import StandardAdhesion from '../Article/StandardArticleLayout/StandardAdhesion';
import { COLLECTION_VIEW, raiseEvent } from '../../lib/gtm';
import theme from '../../lib/theme';
import PageHero from '../../components/presentational/PageHero/PageHero';
const { mediaSizes } = theme;

export interface CollectionProps extends CollectionModel {
  brand?: Brand;
  ads: Ads;
  loadMore: () => any;
  loadPopularArticles: (url: string) => any;
  blocks?: Block[];
  articleIds?: number[];
}

const articleMetadata = (blocks: Block[]) => {
  const articles = blocks.map(block => {
    switch (block.type) {
      case 'article_block':
        return block.articles;
      default:
        return [];
    }
  });
  return articles.length > 0 ? articles.reduce((a, b) => a.concat(b)) : [];
};

// const hasPanelBlock = (blocks: Block[]) =>
//   !!blocks.find(({ type }) => type === 'panel_block');

// const hasTitleBlock = (blocks: Block[]) =>
//   !!blocks.find(({ type }) => type === 'title_block');

const Collection = ({
  brand = 'sas',
  ads,
  // @ts-ignore
  slug,
  moreArticlesLoading,
  title,
  // @ts-ignore
  subtitle,
  link,
  breadcrumbs,
  // @ts-ignore
  categories = [],
  links = [],
  popularArticles = [],
  loadMore,
  author,
  meetups = [],
  styles,
  hideAds,
  blocks = [],
  articleIds,
  // @ts-ignore
  section = 'Discover',
  page_type = 'page',
  categoryDescendents,
  backfillCategory,
  hero,
}: CollectionProps & StylesProps<typeof collectionStyles>) => {
  const isHomePage = page_type === 'homepage';

  //  DEBUGGING
  // useEffect(() => {
  //   console.log('Collection mounted', { hero, title, blocks, isHomePage, categories, links, });
  // }, [blocks, hero, isHomePage, categories]);

  useEffect(() => {
    // console.log('Collection', { hideAds, ads, });
    raiseEvent({
      ...COLLECTION_VIEW,
      ...{
        sasEventType: `COLLECTION_VIEW: ${title}`,
      },
    });
  }, []);

  return (
    <div>
      {/* {ads.high_impact && (
        <div className={styles.highImpact}>
          <Ad
            ad={ads.high_impact}
            inline
            gutter={false}
            predefined
            backgroundColor={'transparent'}
          />
        </div>
      )} */}

      <AdSetup 
        predefineAds={pick(ads, ['standard_adhesion'])} 
        pageLevelTargeting={ads && ads.standard_adhesion ?
          Object.entries(ads.standard_adhesion.targeting || {}).map(([key, value]) => ({ key, value }))
          .concat(
            link && page_type ? 
            [
              { key: 'page_path', value: new URL(link).pathname },
              { key: 'page_category', value: page_type },
            ] : []
          ) : 
          []
        }
      />

      <div className={`${styles.container} collection-container`}>
        <Metadata
          link={link}
          articles={[
            ...articleMetadata(blocks ? blocks : []),
            ...popularArticles,
          ]}
          breadcrumbs={breadcrumbs}
          homepage={isHomePage}
        />

        {/* {!hasTitleBlock(blocks) && author && <AuthorBlock heading author={author} />}
        {!hasTitleBlock(blocks) && !hasPanelBlock(blocks) && title && (
          <NavigationBlock
            title={title}
            subtitle={subtitle}
            breadcrumbs={breadcrumbs}
            links={links}
          />
        )} */}

        {/* {title && (
          <Spacer space={'s'} width={mediaSizes.xxl ?? '1200px'} justify={'center'} style={{ margin: '0 auto' }}>
            <h1 className={cx('collection-heading', styles.heading1)}>{title}</h1>
          </Spacer>
        )} */}

        {hero && (
          <PageHero
            background={hero.background}
            title={hero.title || title || ''}
            description={hero.description || ''}
          />
        )}

        {blocks.map((block, blockIndex) => {

          const hydratedBlock = {
            ...block,
            brand,
            blockIndex,
          };

          // if (block.type == 'title_block') {
          //   return constructNavigationBlock(blocks, blockIndex, title, author, subtitle, breadcrumbs, links)
          // } else {
            return <CollectionBlock
              key={blockIndex}
              block={hydratedBlock}
              ads={ads}
              blockIndex={blockIndex}
              categories={categories || []}
              links={links || []}
              author={author}
              brand={brand}
              popular={popularArticles}
              hideAds={hideAds}
              meetups={meetups}
              loadMore={loadMore}
              articleIds={articleIds}
              moreArticlesLoading={moreArticlesLoading}
              categoryDescendents={categoryDescendents || []}
              backfillCategory={backfillCategory}
              collectionConfig={{ title, subtitle, section, slug, page_type }}
            />
          // }
        })}
      </div>

      {ads.standard_adhesion && !isHomePage && (
        <div className={styles.hiddenAd}>
          <StandardAdhesion
            ad={ads.standard_adhesion}
            section={kebabCase(section.toLowerCase())}
          />
        </div>
      )}
    </div>
  )
};

// const constructNavigationBlock = (blocks, blockIndex, title, author, subtitle, breadcrumbs, links) => {
//   return (
//     <div key={blockIndex} className="title-block-container">
//       {author && <AuthorBlock key={`author-${blockIndex}`} heading author={author} />}
//       {!hasPanelBlock(blocks) && title && (
//         <NavigationBlock
//           title={title}
//           key={`navigation-${blockIndex}`}
//           subtitle={subtitle}
//           breadcrumbs={breadcrumbs}
//           links={links}
//         />
//       )}
//     </div>
//   )
// }

const collectionPropsSelector = memoize(
  collectionSelector,
  adsSelector,
  (collection, ads) => ({ ...collection, ads })
);

const dispatchProps = dispatch => ({
  loadMore: withTracking(SHOW_MORE_STORIES, (url, blockIndex, articleIds) => {
    dispatch(loadMoreArticlesThunk(url, blockIndex, articleIds));
  }),
  loadPopularArticles: () => {
    dispatch(loadPopularArticlesThunk());
  },
});

const featureBlockExists = (blocks: Block[]) => {
  return blocks.filter((block: Block) => {
    return block.type === 'popular_block';
  }).length;
};

const withOnMount = compose(
  withProps(
    ({ blocks, loadPopularArticles, popularArticlesURL }: CollectionProps) => ({
      onMount: () => {
        if (
          popularArticlesURL &&
          (blocks === undefined || featureBlockExists(blocks))
        ) {
          loadPopularArticles(popularArticlesURL);
        }
      },
      articleIds:
        blocks &&
        blocks
          .filter(block => block.type === 'article_block')
          .map((block: ArticleBlockData) =>
            block.articles.map(article => article.id)
          )
          .reduce((acc, val) => acc.concat(val), []),
    })
  ),
  callOnMount('onMount')
);

export default compose(
  connect(collectionPropsSelector, dispatchProps),
  withOnMount,
  styled(collectionStyles)
)(Collection);
